<div class="content-card">
  <alert message="MultipleAgreementGenerationWarning" alertType="error"></alert>
  @if (this.isLegalizationFieldVisible() && workerAgreementLegalizationData) {
    <div
      [visibleWithPermissions]="['LegalizationInformationVisibilityToAll', 'LegalizationInformationVisibilityToEmployerObjects']"
      class="content-card"
      >
      <h2 class="content-card__header">{{ 'Legalization.LegalizationStatus' | translate }}</h2>
      <div class="workers-legalization-grid">
        @for (item of foreignWorkersWithData; track item; let i = $index) {
          <div>
            <app-legalization-status-info
              [element]="item.legalizationData"
              [size]="'large'"
              [showStatusText]="true"
              [showTooltip]="false"
              [showLabel]="true"
              [customLabel]="i + 1 + '. ' + item.name"
            ></app-legalization-status-info>
          </div>
        }
      </div>
      <div>
        <button
          mat-raised-button
          class="legalization-status-btn"
          type="button"
          [matTooltip]="'Legalization.SubmitForMultipeLegalizationInfo' | translate"
          [matTooltipClass]="'line-broken-tooltip'"
          (click)="onSubmitForLegalization()"
          >
          {{ 'Legalization.SubmitForLegalization' | translate }}
        </button>
      </div>
    </div>
  }
  <form [formGroup]="basicInformationStepFormGroup">
    <h2 class="content-card__header">{{ 'AEF-BasicInformation' | translate }}</h2>
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Company' | translate }}</mat-label>
          <mat-select [disabled]="this.isExtension" formControlName="company">
            @for (company of listOfCompanies$ | async; track company) {
              <mat-option #matOption [value]="company.Id">{{ company.Name | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Employer' | translate }}</mat-label>
          <mat-select formControlName="employer" #employerSelect>
            @for (employer of listOfEmployers$ | async; track employer) {
              <mat-option #matOption [value]="employer.Id">{{
                employer.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
          <input
            #employerObjectInput
            matInput
            formControlName="employerObject"
            placeholder="{{ 'EmployerObject' | translate }}"
            [matAutocomplete]="autocompleteEmployerObject"
            />
            <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
              @for (employerObject of listOfEmployerObjects$ | async; track employerObject) {
                <mat-option [value]="employerObject">
                  {{ employerObject.Name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      @if (orderItemActive && hasAssignOrderItemPermission) {
        <div class="row">
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'OrderItem' | translate }}</mat-label>
              <mat-select formControlName="orderItem">
                @for (item of listOfAvailableOrderItems$ | async; track item) {
                  <mat-option #matOption [value]="item"
                    >{{ item.Name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Location' | translate }}</mat-label>
            <input matInput formControlName="location" placeholder="{{ 'Location' | translate }}" [matAutocomplete]="autocompleteLocation" />
            <mat-autocomplete #autocompleteLocation="matAutocomplete" [displayWith]="displayValue">
              @for (location of listOfLocations$ | async; track location) {
                <mat-option [value]="location">
                  {{ location.Name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'MPK' | translate }}</mat-label>
            <input matInput placeholder="{{ 'MPK' | translate }}" formControlName="mpk" autocomplete="given-name" />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Workplace' | translate }}</mat-label>
            <input
              matInput
              formControlName="temporaryWorkplace"
              placeholder="{{ 'Workplace' | translate }}"
              [matAutocomplete]="autocompleteTemporaryWorkplace"
              />
              <mat-autocomplete #autocompleteTemporaryWorkplace="matAutocomplete" [displayWith]="displayValue">
                @for (temporaryWorkplace of listOfTemporaryWorkplaces$ | async; track temporaryWorkplace) {
                  <mat-option [value]="temporaryWorkplace">
                    {{ temporaryWorkplace.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Supervisor' | translate }}</mat-label>
              <input matInput formControlName="supervisor" placeholder="{{ 'Supervisor' | translate }}" [matAutocomplete]="autocompleteSupervisor" />
              <mat-autocomplete #autocompleteSupervisor="matAutocomplete" [displayWith]="displayValue">
                @for (supervisor of listOfSupervisors$ | async; track supervisor) {
                  <mat-option [value]="supervisor">
                    {{ supervisor.Name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <h2 class="content-card__header">{{ 'AgreementType' | translate }}</h2>

        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'AgreementType' | translate }}</mat-label>
              <mat-select formControlName="agreementType">
                @for (agreementType of listOfAgreementTypes$ | async; track agreementType) {
                  <mat-option [value]="agreementType.Id">
                    {{ agreementType.Name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'AgreementConclusionDate' | translate }}</mat-label>
              <input matInput [matDatepicker]="pickConclusionDate" formControlName="conclusionDate" />
              <mat-datepicker-toggle matSuffix [for]="pickConclusionDate"></mat-datepicker-toggle>
              <mat-datepicker #pickConclusionDate></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentDateFrom' | translate }}</mat-label>
              <input
                matInput
                [matDatepicker]="pickEmploymentDateFrom"
                formControlName="employmentDateFrom"
                [matDatepickerFilter]="employmentDateFromFilter"
                (dateChange)="checkDays('change', $event)"
                required
                />
                <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickEmploymentDateFrom></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'EmploymentDateTo' | translate }}</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickEmploymentDateTo"
                  formControlName="employmentDateTo"
                  [matDatepickerFilter]="employmentDateToFilter"
                  (dateChange)="checkDays('change', $event)"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickEmploymentDateTo"></mat-datepicker-toggle>
                  <mat-datepicker #pickEmploymentDateTo></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline" (click)="onOrganizationalUnitClick()">
                  <mat-label>{{ 'OrganizationalUnit' | translate }}</mat-label>
                  <input matInput formControlName="organizationalUnit" [matAutocomplete]="autocompleteOrganizationalUnit" />
                  <mat-icon matSuffix>{{ 'expand_more' }}</mat-icon>
                  <mat-autocomplete #autocompleteOrganizationalUnit="matAutocomplete" [displayWith]="displayValue"> </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'JobTitle' | translate }}</mat-label>
                  <mat-select formControlName="jobTitle">
                    @for (jobTitle of listOfJobTitles$ | async; track jobTitle) {
                      <mat-option #matOption [value]="jobTitle.Id">{{
                        jobTitle.Name | translate
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'JobResponsibilities' | translate }}</mat-label>
                  <mat-select [compareWith]="compareResponsibilities" (keydown)="handleKeydown($event)" formControlName="responsibilities" multiple>
                    <mat-select-trigger>
                      <mat-chip-set class="responsibilities-chip" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)">
                        @for (selectedResponsibilitity of responsibilities.value; track selectedResponsibilitity) {
                          <mat-chip
                            class="responsibilities-box"
                            cdkDrag
                            (removed)="onResponsibilityRemoved(selectedResponsibilitity)"
                            [removable]="true"
                            [matTooltip]="selectedResponsibilitity.Name"
                            >
                            {{ selectedResponsibilitity.Name }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </mat-select-trigger>
                    <mat-form-field style="position: sticky; top: -10px; z-index: 1">
                      <input matInput placeholder="{{ 'Search' | translate }}" (keyup)="onFiltered($event.target.value)" />
                    </mat-form-field>
                    @for (responsibility of filteredResponsibilities$ | async; track responsibility) {
                      <mat-option #matOption [value]="responsibility">
                        {{ responsibility.Name | translate }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (responsibilities.invalid && responsibilities.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <button class="float-right" mat-raised-button color="primary" (click)="submit()" matStepperNext>{{ 'Next' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
